import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const formatINR = (n) => {
  if (n === null || n === undefined) return "";
  if (n >= 10000000) return `₹ ${(n / 10000000).toFixed(2)} Cr`;
  if (n >= 100000) return `₹ ${(n / 100000).toFixed(2)} Lac`;
  return `₹ ${n.toLocaleString("en-IN")}`;
};

export const formatArea = (v, u) => `${v.toLocaleString("en-IN")} ${u}`;

// Standard conversion factors to square feet. `bigha` varies by state — we use the
// Madhya Pradesh convention (Tharlo's primary market): 1 bigha ≈ 27,225 sqft.
const SQFT_PER_UNIT = {
  sqft: 1,
  sqyd: 9,
  acre: 43560,
  bigha: 27225,
};

/**
 * Returns a formatted "₹/sqft" (or "₹/sqft/month" for rent) string for a property.
 * Returns "" if any input is missing / non-positive / unit is unknown.
 * Uses ceil-friendly rounding: numbers >= 100 → integer; smaller → 2 decimals.
 */
export const formatPricePerSqft = (price, areaValue, areaUnit, listingType = "sale") => {
  const p = Number(price);
  const a = Number(areaValue);
  const factor = SQFT_PER_UNIT[areaUnit];
  if (!Number.isFinite(p) || p <= 0 || !Number.isFinite(a) || a <= 0 || !factor) return "";
  const perSqft = p / (a * factor);
  if (!Number.isFinite(perSqft) || perSqft <= 0) return "";
  const rounded = perSqft >= 100 ? Math.round(perSqft).toLocaleString("en-IN") : perSqft.toFixed(2);
  const suffix = listingType === "rent" ? "/sqft/month" : "/sqft";
  return `₹ ${rounded} ${suffix}`;
};
